import { Component, inject } from '@angular/core';
import { rxResource } from '@angular/core/rxjs-interop';
import { OrderService } from '@api-services';
import { CurrencyPipe, DatePipe } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'wun-bo-orders',
  standalone: true,
  imports: [CurrencyPipe, DatePipe, RouterLink],
  templateUrl: './orders.component.html',
  styleUrl: './orders.component.scss'
})
export class OrdersComponent {

  private readonly orderService = inject(OrderService);

  orders = rxResource({
    stream: () => this.orderService.ordersFindAndPaginate({
      includes: JSON.stringify(['rows.artwork.mainAttachment', 'user']),
      sorting: JSON.stringify({ createdAt: 'DESC' })
    })
  });

  statusLabel(status: string): string {
    const map: Record<string, string> = {
      CREATED: 'In attesa',
      PAYED: 'Pagato',
      SHIPPED: 'Spedito',
      DELIVERED: 'Consegnato',
    };
    return map[status] ?? status;
  }

  statusClass(status: string): string {
    const map: Record<string, string> = {
      CREATED: 'bg-yellow-100 text-yellow-800',
      PAYED: 'bg-blue-100 text-blue-800',
      SHIPPED: 'bg-purple-100 text-purple-800',
      DELIVERED: 'bg-green-100 text-green-800',
    };
    return map[status] ?? 'bg-gray-100 text-gray-800';
  }
}
